import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SettingService } from 'src/app/core/service/setting.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit
{
  public errorText: string = null;
  private errorKey: string = null;

  constructor(
    private route: ActivatedRoute,
    private translate: TranslateService,
    private settingService: SettingService) { }

  public ngOnInit(): void
  {
    // Just in case that 401 or 404 occurs in a modal, we must reset overflow to re-enable scrolling.
    document.body.style.overflow = '';
    this.errorKey = this.route.snapshot.params.errorKey || null;
    if (this.errorKey !== null)
    {
      this.translate.get(this.errorKey).subscribe({
        next: (value) =>
        {
          this.settingService.getCachedSessionSettings().subscribe({
            next: (sessionSetting) =>
            {
              if (value.includes('{{patientLabel}}'))
              {
                this.errorText = value.replace('{{patientLabel}}', sessionSetting.patientLabel);
              }
              else
              {
                this.errorText = value;
              }
            }
          });
        }
      });
    }
  }
}
